import React from 'react';
import { TableHeader } from './TableHeader';

export function TableHeaderWithColumnType<T>(props: {
    column: T; currentColumn: T; title: string; sortOrder: 'asc' | 'desc';
    getColumn: (val: T) => string;
}) {
    return (
        <TableHeader
            title={props.title}
            sortOrder={props.currentColumn === props.column ? props.sortOrder : null}
            column={props.getColumn(props.column)}></TableHeader>
    );
}
